// extracted by mini-css-extract-plugin
module.exports = {"adminLayout":"AdminLayout_adminLayout__B5iR7","containerWrapper":"AdminLayout_containerWrapper__29VP2"};